/** Mirrors `MAX_ATTACHMENT_BYTES` in the API's multer config — a larger file is rejected there. */
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;

/**
 * Splits a pick into what can go up and what cannot, with the sentence to show for the latter.
 * `null` message when nothing was too large.
 */
export function splitOversized(files: File[]): { accepted: File[]; message: string | null } {
  const oversized = files.filter((f) => f.size > MAX_UPLOAD_BYTES);
  const accepted = files.filter((f) => f.size <= MAX_UPLOAD_BYTES);
  const message =
    oversized.length === 0
      ? null
      : oversized.length === 1
        ? `"${oversized[0].name}" ist zu groß (max. 10 MB).`
        : `${oversized.length} Dateien überschreiten 10 MB und wurden ignoriert.`;
  return { accepted, message };
}
